import { LOCAL_STORAGE_KEY } from "../Config";

export default function authHeader() {
  const user = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
  if (user) {
    return user;
  }
  return null;
}
export function localData() {
  const user = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
  if (user?.length > 0) {
    return user;
  }
  return null;
}
